module.exports = "/_next/static/images/d8007b4f18485d51116f91dbb95f1c2a-people-smile-at-home-lg@2x.jpg";